import { useSession } from '../../state/session';
import { Modal } from '../../ui';
import { ForgotPasswordForm } from './ForgotPasswordForm';
import { LoginForm } from './LoginForm';
import { RegisterForm } from './RegisterForm';
import { SocialAuth } from './SocialAuth';
import styles from './auth.module.css';

const TITLES = {
  login: 'Welcome back',
  register: 'Create your account',
  forgot: 'Reset your password',
};

const SUBTITLES = {
  login: 'Sign in to book rooms and manage your stays.',
  register: 'Book hotel rooms by the hour in a few taps.',
  forgot: 'We’ll email you a link to choose a new one.',
};

/** Global sign-in / sign-up dialog, opened via useSession().openAuth(). */
export function AuthDialog() {
  const { auth, closeAuth, setAuthView } = useSession();
  const { open, view, reason, email } = auth;

  return (
    <Modal
      open={open}
      onClose={closeAuth}
      title={TITLES[view]}
      description={reason || SUBTITLES[view]}
      size="sm"
      fullscreenOnMobile
    >
      <div className={styles.dialogBody}>
        {view !== 'forgot' && (
          <>
            <SocialAuth />
            <div className={styles.divider}>
              <span>or with email</span>
            </div>
          </>
        )}

        {view === 'login' && <LoginForm defaultEmail={email} onForgotPassword={() => setAuthView('forgot')} />}
        {view === 'register' && <RegisterForm defaultEmail={email} />}
        {view === 'forgot' && <ForgotPasswordForm onBack={() => setAuthView('login')} />}

        {view === 'login' && (
          <p className={styles.switch}>
            New to Nappr?{' '}
            <button type="button" className={styles.inlineLink} onClick={() => setAuthView('register')}>
              Create an account
            </button>
          </p>
        )}
        {view === 'register' && (
          <p className={styles.switch}>
            Already have an account?{' '}
            <button type="button" className={styles.inlineLink} onClick={() => setAuthView('login')}>
              Sign in
            </button>
          </p>
        )}
      </div>
    </Modal>
  );
}
